<template>
  <div class="board-content">
    <!-- <div class="week">
      <div class="week-title">
        <h3>周累充返利</h3>
        <p>{{ state.nowweekTime }} &nbsp;| &nbsp;</p>
        <p>
          已充值 <span>{{ state.myWeekData.usersum }}余额</span>
        </p>
      </div>
      <div class="week-content">
        <li v-for="(item, index) in state.rebateList" :key="item.id + 'rebate'">
          <img :src="item.pic" alt="" />
          <p v-if="item.status == 0">未达成</p>
          <p
            v-else-if="item.status == 1"
            @click="getPayReword(item.id)"
            class="notGet"
          >
            领取
          </p>
          <p v-else-if="item.status == 2">已领取</p>
        </li>
      </div>
    </div> -->
    <div class="week-list">
      <div class="list-title">
        <img src="../../assets/personal/cash/week_list_title.png" alt="" />
        <p>榜单周期:{{ state.nowweekTime }}</p>
      </div>
      <div class="top-three">
        <li
          v-for="(item, index) in state.weekList.top"
          :key="item.pay_to_account"
        >
          <div class="avatar"><img :src="item.avatar" alt="" /></div>
          <h4>
            <van-notice-bar :text="item.user_nicename" :speed="30" />
          </h4>

          <p>累充值 {{ item.pay_money }}</p>
        </li>
      </div>
      <div class="top-other">
        <ul class="table-header">
          <li>排名</li>
          <li>玩家</li>
          <li>累充值</li>
        </ul>
        <ul class="table-body" @touchmove.stop>
          <li
            v-for="(item, index) in state.weekList.other"
            :key="item.pay_to_account"
            class="custom-row"
          >
            <span scope="row">{{ index + 4 }}</span>
            <p><img :src="item.avatar" alt="" />{{ item.user_nicename }}</p>
            <span>{{ item.pay_money }}</span>
          </li>
        </ul>
        <div class="my-top">
          <h4>我的排名:{{ state.myWeekData.paiming }}</h4>
          <p>{{ state.myWeekData.usersum }}</p>
        </div>
      </div>
      <div class="top-info">
        <img
          class="info-title"
          src="../../assets/personal/cash/top_info_title.png"
        />
        <ul>
          <img
            src="http://oss.zhekoushenqi.com/data/thecharts/no1.png"
            alt=""
          />
          <img
            src="http://oss.zhekoushenqi.com/data/thecharts/no2.png"
            alt=""
          />
          <img
            src="http://oss.zhekoushenqi.com/data/thecharts/no3.png"
            alt=""
          />
          <img
            src="http://oss.zhekoushenqi.com/data/thecharts/no4-10.png"
            alt=""
          />
        </ul>
      </div>
    </div>
    <!-- 上周榜单 -->
    <div class="week-list last-week" v-if="state.lastWeekList.top.length > 0">
      <div class="list-title">
        <img src="../../assets/personal/cash/week_list_title_last.png" alt="" />
        <p>榜单周期:{{ state.lastweekTime }}</p>
      </div>
      <div class="top-three">
        <li
          v-for="(item, index) in state.lastWeekList.top"
          :key="item.pay_to_account"
        >
          <div class="avatar"><img :src="item.avatar" alt="" /></div>
          <h4><van-notice-bar :text="item.user_nicename" :speed="30" /></h4>
          <p>累充值 {{ item.pay_money }}</p>
        </li>
      </div>
      <div class="top-other">
        <ul class="table-header">
          <li>排名</li>
          <li>玩家</li>
          <li>累充值</li>
        </ul>
        <ul class="table-body" @touchmove.stop>
          <li
            v-for="(item, index) in state.lastWeekList.other"
            :key="item.pay_to_account"
            class="custom-row"
          >
            <span scope="row">{{ index + 4 }}</span>
            <p><img :src="item.avatar" alt="" />{{ item.user_nicename }}</p>
            <span>{{ item.pay_money }}</span>
          </li>
        </ul>
      </div>
      <div class="my-top">
        <h4>我的排名</h4>
        <p>{{ state.lastpaiming }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onActivated, onMounted, reactive } from "vue";
import { week_pay, week_pay_get } from "@/api/yzpay";
import store from "@/store";
import { Toast } from "vant";
import { formatDateRange } from "@/utils/date";
import { getQueryString } from "@/utils/location";

const state = reactive({
  username: "",
  uid: "",
  // 上周累充数据
  lastWeekList: {
    top: [],
    other: [],
  },
  // 本周累充数据
  weekList: {
    top: [],
    other: [],
  },
  // 返利信息
  rebateList: [],
  // 我的本周数据
  myWeekData: {},
  // 我的上周数据
  lastpaiming: "",
  nowweekTime: "",
  lastweekTime: "",
});

onMounted(() => {
  state.username = getQueryString("username");
  state.uid = getQueryString("uid");
  // 获取周累充数据
  getWeekPay();
});

const getWeekPay = async () => {
  try {
    let res = await week_pay({
      username: state.username,
      uid: getQueryString("uid"),
    });
    if (res.data.code == 1) {
      console.log("接口周累充数据------", res);
      // state.lastWeekList = res.data.data.lastlist;
      state.lastWeekList.top = res.data.data.lastlist.slice(0, 3);
      state.lastWeekList.other = res.data.data.lastlist.slice(3);
      // 截取前10条
      state.weekList.top = res.data.data.list.slice(0, 3);
      state.weekList.other = res.data.data.list.slice(3);
      state.rebateList = res.data.data.ptb_fanli;
      state.myWeekData.paiming = res.data.data.paiming;
      state.myWeekData.usersum = res.data.data.usersum;
      state.nowweekTime = formatDateRange(res.data.data.nowweektime);
      state.lastweekTime = formatDateRange(res.data.data.lastweektime);
      state.lastpaiming = res.data.data.lastpaiming;
    } else {
      Toast(res.data.msg);
    }
  } catch (error) {
    console.log("周累充数据", error);
  }
};

var fetchFlag = false;
const getPayReword = async (id) => {
  if (fetchFlag) return;
  fetchFlag = true;
  try {
    let res = await week_pay_get({
      username: state.username,
      fid: id,
      uid: getQueryString("uid"),
    });
    fetchFlag = false;
    console.log("领取返利------------------", res);
    if (res.data.code == 1) {
      getWeekPay();
    }
    Toast(res.data.msg);
  } catch (error) {
    console.log("返利数据", error);
  }
};
</script>
<style scoped>
.board-content {
  margin-top: 32px;
  padding: 0 32px;
}
.board-content .week {
  width: 100%;
  height: 306px;
  background: linear-gradient(179deg, #ffe9e3 0%, #ffffff 20%);
  border-radius: 30px;
  padding: 24px 0 24px 32px;
}
.week .week-title {
  display: flex;
  align-items: center;
}
.week .week-title h3 {
  font-size: 32px;
  position: relative;
  z-index: 1;
  margin-right: 8px;
}
.week .week-title h3::before {
  content: "";
  display: inline-block;
  background-color: #82f2ff;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  position: absolute;
  z-index: -1;
  left: -6px;
}
.week .week-title p {
  color: #666666;
  font-size: 20px;
  font-weight: 600;
}
.week .week-title p span {
  color: #00d9c3;
}
.week .week-content {
  margin-top: 20px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
}
.week .week-content li {
  width: 160px;
  height: 200px;
  border-radius: 30px;
  background-color: #ffe9e3;
  flex-shrink: 0;
  margin-right: 12px;
  position: relative;
}
.week .week-content li img {
  width: 100%;
  height: 100%;
}
.week .week-content li p {
  position: absolute;
  bottom: 16px;
  font-size: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #c38f8a;
}
.week .week-content li p.notGet {
  border-radius: 198px;
  display: flex;
  background-color: #8e4c32;
  color: #fff;
  padding: 0 16px;
  white-space: nowrap;
}

/* 每周累充榜 */
.week-list {
  margin-top: 32px;
  width: 100%;
  height: 1476px;
  border-radius: 30px;
  background-image: url(../../assets/personal/cash/week_list_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0 32px;
}
.week-list .list-title {
  padding-top: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.week-list .list-title img {
  height: 66px;
  margin-bottom: 12px;
}
.week-list .list-title p {
  padding: 4px 12px;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: #ffffff;
  background-color: #ff7352;
  border-radius: 198px;
}
/* 前三名 */
.top-three {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 46px;
  position: relative;
  padding-top: 20px;
}
.top-three li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 38px;
  width: 184px;
  position: relative;
}
.top-three li .avatar {
  width: 152px;
  height: 152px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.top-three li img {
  width: 92px;
  height: 92px;
  border-radius: 50%;
}
.top-three li:nth-of-type(1) {
  order: 1;
  margin: 0 12px;
}
.top-three li:nth-of-type(1) .avatar::before {
  content: "";
  display: inline-block;
  width: 152px;
  height: 152px;
  border-radius: 50%;
  position: absolute;
  background-image: url(../../assets/personal/cash/top_one.png);
  background-size: 100% 100%;
}
.top-three li:nth-of-type(2) {
  order: 0;
}
.top-three li:nth-of-type(2) .avatar::before {
  content: "";
  display: inline-block;
  width: 152px;
  height: 152px;
  border-radius: 50%;
  position: absolute;
  background-image: url(../../assets/personal/cash/top_two.png);
  background-size: 100% 100%;
}
.top-three li:nth-of-type(3) {
  order: 2;
}
.top-three li:nth-of-type(3) .avatar::before {
  content: "";
  display: inline-block;
  width: 152px;
  height: 152px;
  border-radius: 50%;
  position: absolute;
  background-image: url(../../assets/personal/cash/top_three.png);
  background-size: 100% 100%;
}
.top-three li h4 {
  font-size: 24px;
  margin-bottom: 4px;
  width: 100%;
}
.top-three li h4 :deep(.van-notice-bar) {
  width: 100%;
  background: none;
  color: #333333;
  padding: 0;
  text-align: center;
  height: 40px;
}
.top-three li h4 :deep(.van-notice-bar__wrap) {
  justify-content: center;
}
.top-three li p {
  font-size: 16px;
  color: #5ca59d;
}
.last-week .top-three {
  padding-top: 0;
}
/* 其他玩家 */
.top-other {
  margin: 50px auto 0;
  position: relative;
  width: 622px;
  height: 548px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid #ffffff;
  padding: 32px 32px 0 32px;
  font-size: 24px;
  display: inline-block;
}
.top-other .table-header {
  width: 100%;
  display: flex;
  margin-bottom: 32px;
}
.top-other .table-header li {
  font-size: 24px;
  color: #999999;
}
.top-other .table-header li:nth-of-type(1) {
  margin-right: 90px;
}
.top-other .table-header li:nth-of-type(2) {
  flex: 1;
}
.top-other .table-body {
  height: 420px;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 100px;
}
.top-other .table-body .custom-row {
  width: 100%;
  display: flex;
  margin-bottom: 24px;
  font-weight: bold;
  align-items: center;
  font-size: 24px;
}
.top-other .table-body .custom-row span:nth-of-type(1) {
  width: 48px;
  text-align: center;
  margin-right: 6px;
  font-size: 36px;
}
.top-other .table-body .custom-row p {
  flex: 1;
  display: flex;
  align-items: center;
}
.top-other .table-body .custom-row p img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 24px;
}

.top-other .table-body .custom-row span:nth-of-type(2) {
  color: #5ca59d;
}
/* 我的排名 */
.my-top {
  position: absolute;
  bottom: 0;
  left: -1px;
  width: 622px;
  height: 100px;
  border-radius: 30px;
  background: rgba(255, 227, 191, 0.6);
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 32px;
  font-size: 32px;
  backdrop-filter: blur(12px);
  font-weight: 600;
}
.my-top p {
  color: #5ca59d;
}
.top-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  width: 100%;
}
.top-info .info-title {
  height: 29px;
  margin-bottom: 24px;
}
.top-info ul {
  display: grid;
  grid-template-columns: 226px 182px 182px;
  grid-template-rows: 144px 144px;
  grid-row-gap: 14px;
  grid-column-gap: 16px;
}
.top-info ul img {
  width: 182px;
  height: 144px;
}
.top-info ul img:nth-of-type(1) {
  width: 226px;
  height: 302px;
  grid-column: 1;
  grid-row: 1;
}
.top-info ul img:nth-of-type(4) {
  grid-column: 2;
  grid-row: 2;
  width: 380px;
  height: 144px;
}

/* 上周榜单 */
.last-week {
  height: auto;
  background-size: 100%;
  padding-bottom: 40px;
}
.last-week .my-top {
  position: relative;
  margin-top: 30px;
}
</style>
